import axios from "axios";
import { axiosService } from "./axiosService";
export default axiosService(axios);
